"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = require("react");
var AuthenticationContext_1 = tslib_1.__importDefault(require("./AuthenticationContext"));
function useAuthentication() {
    var _a = react_1.useContext(AuthenticationContext_1["default"]), logout = _a.logout, authenticated = _a.authenticated, authenticating = _a.authenticating, error = _a.error, getToken = _a.getToken;
    return [logout, { authenticated: authenticated, authenticating: authenticating, error: error, token: getToken() }];
}
exports["default"] = useAuthentication;
//# sourceMappingURL=useAuthentication.js.map